<template>
  <Transition name="modal">
    <div v-if="showModalMain" class="modal-mask" id="modalPopupFreetour">
      <div class="modal-container">
        <div class="modal-header">
          <button class="close-black" @click="closeModalPopupFreetour()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body">
          <video
            ref="videoLoop"
            controls
            loop
            @play="gtmPlayVideo('freetour', 'pop_up', 'Modal Popup')"
            @timeupdate="checkNearEnd"
            @loadedmetadata="gtmViewVideo('freetour', 'pop_up', 'Modal Popup')"
          >
            <source :src="video" />
          </video>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { gtmViewVideo, gtmPlayVideo, gtmFinishVideo } from "~/util/gtm-videos";
const video = ref("");
const videoLoop = ref<HTMLVideoElement | null>(null);
const props = defineProps({
  optionsModalFreetour: {
    type: Object,
    required: true,
  },
});

const showModalMain = ref(false);

function closeModalPopupFreetour() {
  showModalMain.value = false;
}

function checkNearEnd() {
  const v = videoLoop.value;
  if (v && v.duration - v.currentTime < 0.2) {
    gtmFinishVideo("freetour", "pop_up", "Modal Popup");
  }
}

watch(props.optionsModalFreetour, () => {
  if (props.optionsModalFreetour.videoPath) {
    video.value = props.optionsModalFreetour.videoPath;
    setTimeout(() => {
      showModalMain.value = true;
    }, parseInt(props.optionsModalFreetour.videoTime) * 1000);
  }
});
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 700px;
  margin: auto;
  padding: 0px 0px;
  background-color: unset;
  box-shadow: unset;
  transition: all 0.3s ease;
}

.modal-header,
.modal-header-footer {
  display: block;
  text-align: center;
}

.modal-body,
.modal-body-footer {
  margin: 0;
  padding: 0px 0px;
}

.modal-default-button {
  float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-black {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 1;
}

.modal-body video {
  width: 700px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container,
  .modal-container-footer {
    width: 95%;
  }

  :deep(.modal-body-footer img) {
    width: 100%;
    height: auto;
  }

  .close-modal {
    width: 20px;
    height: 20px;
    margin: 5px;
  }

  .modal-body video {
    width: 100%;
  }

  .close-black {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
  }
}
</style>
